class FluxStatisticsChats {
  constructor(document) {
    document = document || {}
    this.auto = document.auto || 0
    this.manual = document.manual || 0
    this.closed = document.closed || 0
    this.missed = document.missed || 0
    this.offline = document.offline || 0
  }
}

module.exports = FluxStatisticsChats
